export const TRIAL_MODEL = 'gpt-5.4-mini';
export const TRIAL_DISABLED_TOOLTIP = "This model isn't available yet.";
export const MODEL_SELECTION_TOOLTIP =
  "Only the models you can select are available right now. Want access to others? Let us know at info@sacher.ai, we'd love to hear which ones matter to you.";
